// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/api/util/response_status.proto (package knop.ui.v1.api.util, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum knop.ui.v1.api.util.ResponseStatus
 */
export enum ResponseStatus {
  /**
   * @generated from enum value: UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: FAILED = 2;
   */
  FAILED = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ResponseStatus)
proto3.util.setEnumType(ResponseStatus, "knop.ui.v1.api.util.ResponseStatus", [
  { no: 0, name: "UNKNOWN" },
  { no: 1, name: "SUCCESS" },
  { no: 2, name: "FAILED" },
]);

